/** Customers / users / roles / CRM feature reducers */
export async function loadCustomersReducers() {
  const [
    combinedUsers,
    appUserAddresses,
    customerComplaints,
    customerOrders,
    appUsersGroups,
    role,
    feedback,
    customerCredit,
  ] = await Promise.all([
    import('../reducers/CombinedUsersReducer'),
    import('../reducers/AppUserAddressesReducer'),
    import('../reducers/CustomerComplaintsReducer'),
    import('../reducers/CustomerOrdersReducer'),
    import('../reducers/AppUsersGroupsReducer'),
    import('../reducers/RoleReducer'),
    import('../reducers/FeedbackReducers'),
    import('../reducers/CustomerCreditReducer'),
  ]);

  return {
    combinedUsers: combinedUsers.default,
    appUserAddresses: appUserAddresses.default,
    customerComplaints: customerComplaints.default,
    customerOrders: customerOrders.default,
    appUsersGroups: appUsersGroups.default,
    role: role.default,
    feedback: feedback.default,
    customerCredit: customerCredit.default,
  };
}
